import React from 'react';
import { useTranslation } from 'react-i18next';
import { format } from 'date-fns';
import { he, enUS } from 'date-fns/locale';

interface ConfirmationViewProps {
  treatmentTitle?: string;
  treatmentName?: string;
  duration?: number;
  selectedDate: Date;
  selectedTime: string;
}

const ConfirmationView: React.FC<ConfirmationViewProps> = ({ treatmentTitle, treatmentName, duration, selectedDate, selectedTime }) => {
  const { t, i18n } = useTranslation();
  const locale = i18n.language === 'he' ? he : enUS;
  const isRtl = i18n.language === 'he';

  return (
    <div className="p-4 text-center">
      <h3 className="text-success mb-4">{t('appointment-booked-successfully')}</h3>

      <p><strong>{treatmentTitle}</strong></p>
      <p className="h5">{treatmentName}</p>
      <p>{duration} {t('min')}</p>
      <p>
        {selectedTime} - {format(selectedDate, 'EEEE, MMMM d, yyyy', { locale })}
      </p>
      <p>{t('local-time')}</p>
    </div>
  );
};

export default ConfirmationView;
